import {createFeature, StoreModule} from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import {viewReducer} from './reducer/view.reducer';

export const viewStoreConfig = StoreModule.forFeature(
  createFeature({
    name: StoreKeys.VIEW,
    reducer: viewReducer
  }));
